// removed by extract-text-webpack-plugin
module.exports = {"SiteSearch":"SiteSearch","pc":"pc","SiteSearch__container":"SiteSearch__container","SiteSearch__inner":"SiteSearch__inner","SiteSearch__code":"SiteSearch__code","button-clear":"button-clear","SiteSearch__link-open":"SiteSearch__link-open","SiteSearch__border":"SiteSearch__border","SiteSearch__link-close":"SiteSearch__link-close","open":"open","mb":"mb","sug_list":"sug_list","sug_element":"sug_element","current_element":"current_element"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/site-search/styles.css
// module id = 151
// module chunks = 0 1